<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <sequential-entrance from-top>
      <v-row>
        <v-col
          sm="12"
          md="12"
          lg="12"
        >
          <base-material-card
            color="primary"
            icon="mdi-group"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Change Order Profiles
              </div>
            </template>
            <v-data-table
              :headers="headers_order"
              :items="getprofiles"
              :search="search"
              :single-expand="singleExpand"
              item-key="key"
              :expanded.sync="expanded"
              expand-icon="mdi-chevron-down"
              sort-by="group"
              sort-desc
              show-expand

              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                >
                  <v-toolbar-title>Profiles</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  />
                  <v-spacer />
                  <v-dialog
                    v-model="dialog"
                    max-width="500px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        New Profile
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="editedItem.label"
                                :rules="must_exist"
                                placeholder="Profile Name"
                                outlined
                                label="Profile Name"
                              />
                              <v-select
                                v-model="editedItem.group"
                                :items="grouplist"
                                label="Group"
                              />
                              <v-text-field
                                v-model="editedItem.Notes5"
                                :rules="fives_by_hundreds_only"
                                placeholder="Groups of $100"
                                outlined
                                label="Fives"
                              />
                              <v-text-field
                                v-model="editedItem.Notes1"
                                :rules="ones_by_hundreds_only"
                                placeholder="Groups of $100"
                                outlined
                                label="Ones"
                              />

                              <v-text-field
                                v-model="editedItem.Coin025"
                                :rules="quarters_by_ten_only"
                                placeholder="Groups of $10"
                                outlined
                                label="Quarters"
                              />
                              <v-text-field
                                v-model="editedItem.Coin010"
                                :rules="dimes_by_five_only"
                                placeholder="Groups of $5"
                                outlined
                                label="Dimes"
                              />
                              <v-text-field
                                v-model="editedItem.Coin005"
                                :rules="nickles_by_two_only"
                                placeholder="Groups of $2"
                                outlined
                                label="Nickels"
                              />
                              <v-text-field
                                v-model="editedItem.Coin001"
                                :rules="pennies_by_fiftycents_only"
                                placeholder="Groups of $0.50"
                                outlined
                                label="Pennies"
                              />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="warning"
                          @click="close"
                        >
                          Clear
                        </v-btn>
                        <v-btn
                          color="primary"
                          :disabled="!formIsValid"
                          @click="saveprofile"
                        >
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog
                    v-model="dialogDelete"
                    max-width="600px"
                  >
                    <v-card>
                      <v-card-title class="headline">
                        Are you sure you want to delete this item?
                      </v-card-title>
                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="closeDelete"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="deleteItemConfirm"
                        >
                          OK
                        </v-btn>
                        <v-spacer />
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td
                  :colspan="headers.length"
                  class="white"
                >
                  <v-row>
                    <v-col
                      lg="6"
                      md="6"
                    >
                      <v-card>
                        <v-card-title>
                          Coins
                        </v-card-title>
                        <v-list>
                          <v-list-item-group>
                            <v-list-item>
                              Pennies: {{ format_amt(item.Coin001) }}
                            </v-list-item>
                            <v-list-item>
                              Nickels: {{ format_amt(item.Coin005) }}
                            </v-list-item>
                            <v-list-item>
                              Dimes: {{ format_amt(item.Coin010) }}
                            </v-list-item>
                            <v-list-item>
                              Quarters: {{ format_amt(item.Coin025) }}
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-card>
                    </v-col>
                    <v-col
                      lg="6"
                      md="6"
                    >
                      <v-card>
                        <v-card-title>
                          Notes
                        </v-card-title>
                        <v-list>
                          <v-list-item-group>
                            <v-list-item>
                              Ones: {{ format_amt(item.Notes1) }}
                            </v-list-item>
                            <v-list-item>
                              Fives: {{ format_amt(item.Notes5) }}
                            </v-list-item>
                            <v-list-item>
                              Tens: {{ format_amt(item.Notes10) }}
                            </v-list-item>
                            <v-list-item>
                              Twenties: {{ format_amt(item.Notes20) }}
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-card>
                    </v-col>
                  </v-row>
                </td>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="editItem(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  small
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <template v-slot:no-data>
                <v-btn
                  color="primary"
                  @click="initialize"
                >
                  No Data
                </v-btn>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'
  var numeral = require('numeral')

  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      search: '',
      expanded: [],
      singleExpand: true,
      rels: [],
      headers_order: [
        { text: 'Label', align: 'left', value: 'label', sortable: true },
        { text: 'Group', align: 'left', value: 'group', sortable: true },
        { text: 'Actions', align: 'center', value: 'actions', sortable: true },
      ],
      profiles: [],
      must_exist: [
        v => !!v || 'Please Enter a value'
      ],
      numeric_only: [
        // v => !!v || 'Please set empty fields to 0',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
      ],
      currency_by_thousands_only: [
        // v => !!v || 'Please set empty fields to 0',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
        v => (v) % 1000 === 0 || 'Available only by thousands',
      ],
      tens_by_hundreds_only: [
        // v => !!v || 'Please set empty fields to 0',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
        v => (v) % 100 === 0 || 'Available only by hundreds',
      ],
      fives_by_hundreds_only: [
        // v => !!v || 'Please set empty fields to 0',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
        v => (v) % 100 === 0 || 'Available only by hundreds',
      ],
      ones_by_hundreds_only: [
        // v => !!v || 'Please set empty fields to 0',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
        v => (v) % 100 === 0 || 'Available only by hundreds',
      ],
      pennies_by_fiftycents_only: [
        v => !isNaN(v) || 'Please format as 0.00',
        v => (v) % 0.50 === 0 || 'Available only by 0.50',
      ],
      nickles_by_two_only: [
        // v => !!v || 'Please set empty fields to 0',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
        v => (v) % 2 === 0 || 'Available only by twos',
      ],
      dimes_by_five_only: [
        // v => !!v || 'Please set empty fields to 0',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
        v => (v) % 5 === 0 || 'Available only by fives',
      ],
      quarters_by_ten_only: [
        // v => !!v || 'Please set empty fields to 0',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
        v => (v) % 10 === 0 || 'Available only by tens',
      ],
      editedIndex: -1,
      editedItem: {
        key: '',
        label: '',
        group: '',
        BagNumber: '',
        TrackingNumber: '',
        // or LocationNumber but NOT BOTH
        DepositDate: '',
        BagNumber: '',
        Notes1: '',
        Notes2: '',
        Notes5: '',
        Notes10: '',
        Notes20: '',
        Notes50: '',
        Notes100: '',
        CurrencyAmount: '',
        Coin001: '',
        Coin005: '',
        Coin010: '',
        Coin025: '',
        CoinAmount: '',
        CheckCount: '',
        CheckAmount: '',
        DepositAmount: 0,
      },
      defaultItem: {
        key: '',
        label: '',
        group: '',
        BagNumber: '',
        TrackingNumber: '',
        // or LocationNumber but NOT BOTH
        DepositDate: '',
        BagNumber: '',
        Notes1: '',
        Notes2: '',
        Notes5: '',
        Notes10: '',
        Notes20: '',
        Notes50: '',
        Notes100: '',
        CurrencyAmount: '',
        Coin001: '',
        Coin005: '',
        Coin010: '',
        Coin025: '',
        CoinAmount: '',
        CheckCount: '',
        CheckAmount: '',
        DepositAmount: 0,
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Profile' : 'Edit Profile'
      },
      grouplist () {
        // return []
        let groups = this.$store.getters.usergroups.map(
          group => group.name
        )
        return groups
      },
      loading () {
        // return true
        return this.$store.getters.getloading
      },
      getprofiles () {
        this.rels = []
        this.rels = this.$store.getters.getLoadedChangeProfiles
        return this.rels
      },
      formIsValid () {
        return this.editedItem.label !== '' &&
          this.editedItem.group != ''
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.rels = []
      this.$store.dispatch('loadChangeProfile')
    },

    methods: {
      format_time (ts) {
        this.$log.debug('TS ', ts)
        return moment(ts).format('YYYY-MM-DD HH:mm')
      },
      format_amt (amt) {
        this.$log.debug('amt ', amt)
        return numeral(amt).format('$0,0.00')
      },
      editItem (item) {
        this.editedIndex = this.rels.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.rels.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.rels.splice(this.editedIndex, 1)
        this.$store.dispatch('deleteChangeProfile', this.editedItem)

        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      saveprofile () {
        // calc total notes
        // calc total coin
        // calc total order amount
        console.log(this.editedItem)
        let notestotal = 0
        if (this.editedItem.Notes1 !== '') {
          notestotal += parseInt(this.editedItem.Notes1)
        }
        if (this.editedItem.Notes2 !== '') {
          notestotal += parseInt(this.editedItem.Notes2)
        }
        if (this.editedItem.Notes5 !== '') {
          notestotal += parseInt(this.editedItem.Notes5)
        }
        if (this.editedItem.Notes10 !== '') {
          notestotal += parseInt(this.editedItem.Notes10)
        }
        if (this.editedItem.Notes20 !== '') {
          notestotal += parseInt(this.editedItem.Notes20)
        }
        if (this.editedItem.Notes50 !== '') {
          notestotal += parseInt(this.editedItem.Notes50)
        }
        if (this.editedItem.Notes100 !== '') {
          notestotal += parseInt(this.editedItem.Notes100)
        }

        let cointotal = 0
        if (this.editedItem.Coin001 !== '') {
          cointotal += parseFloat(this.editedItem.Coin001)
        }
        if (this.editedItem.Coin005 !== '') {
          cointotal += parseFloat(this.editedItem.Coin005)
        }
        if (this.editedItem.Coin010 !== '') {
          cointotal += parseFloat(this.editedItem.Coin010)
        }
        if (this.editedItem.Coin025 !== '') {
          cointotal += parseFloat(this.editedItem.Coin025)
        }
        this.editedItem.CoinAmount = cointotal
        this.editedItem.CurrencyAmount = notestotal
        this.editedItem.DepositAmount = cointotal + notestotal
        console.log('notes', notestotal, ' coin ', cointotal)
        if (this.editedIndex > -1) {
          Object.assign(this.rels[this.editedIndex], this.editedItem)
          this.$store.dispatch('updateChangeProfile', this.editedItem)
        } else {
          this.rels.push(this.editedItem)
          this.$store.dispatch('createChangeProfile', this.editedItem)
        }
        this.$store.dispatch('loadChangeProfile')
        this.close()
      },
    },
  }
</script>
